angular.module('lf.desktop')

.controller('CartCtrl', function ($scope, $rootScope, cartService, preloadData, gtmService, $filter) {
  var button, overrideWarnings, shippingOptions, form = {};
  $scope.form = form;
  $scope.promotionCodeRequesting = false;
  $scope.checkoutCart = false;
  $scope.checkout = function($event) {
    if (overrideWarnings || preloadData.siteProductType == 'hardgoods') {
      return;
    }
    button = $($event.target);
    var itemsByStatus = {};

    for (var i = 0, items = $rootScope.shop.softgoodsCart.items, length = items.length;i < length;i++) {
      var item = items[i];
      if (item.eligibility) {
        var status = item.eligibility.status;
        var statusItems = itemsByStatus[status] || [];
        statusItems.push(item);
        itemsByStatus[status] = statusItems;
      }
    }

    if (itemsByStatus.WARNING || itemsByStatus.ERROR) {
      $event.preventDefault();
      $scope.itemsByStatus = itemsByStatus;
      //slideinService.show("eligibility" + (itemsByStatus.ERROR ? 'Error' : 'Warning'));
      // TODO-- temp workaround until we have ng-ized popups for desktop
      Amplifi.overlays.progShowOverlay('#productCompatibilityOverlay');
      $scope.closeOverlay = function() {
        Amplifi.overlays.closeCurrent();
      };
      return;
    };

    $scope.checkoutCart = true;
  };
  
  $scope.checkoutOverrideWarnings = function($event) {
    if (button) {
      overrideWarnings = true;
      setTimeout(function() { 
        button.closest('form').submit();
      }, 0);
    };
  };
  
  var coupon = preloadData.shop.softgoodsCart.pricing.coupon;
  $scope.couponForm = {};
  if (coupon) {  
    $scope.couponForm.couponCode = coupon.requestedCode ? coupon.requestedCode : coupon.orderCode;
  }
  
  $scope.applyCoupon = function($event) {
    $event.preventDefault();
    $scope.promotionCodeRequesting = true;
    cartService.applyCoupon({couponCode: $scope.couponForm.couponCode})
      .then(function () {
        $scope.promotionCodeRequesting = false;
      });
  };
  
  $scope.showEligibilityDetail = function(item) {
    $scope.eligibilityItem = item;
    //slideinService.show('eligibilityDetail');
  };
  
  $scope.getShippingOptions = function($event) {
    $event.preventDefault();
    cartService.getShippingOptions({postalCode: form.shippingPostalCode})
      .success(function(data) {
        $rootScope.shop.hardgoodsCart.shippingOptions = data.shippingMethods;
      });
  };
  
  $scope.selectShippingOption = function(shippingOption) {
    var pricing = $rootScope.shop.hardgoodsCart.pricing;
    if (pricing.shippingAmount.val > 0) {
      pricing.orderTotalWithoutDiscount.val = (pricing.orderTotalWithoutDiscount.val - pricing.shippingAmount.val);
    }
    pricing.shippingAmount.val = shippingOption.shippingAmountRaw;
    pricing.shippingAmount.fmt = shippingOption.shippingAmount;
    pricing.orderTotalWithoutDiscount.val = pricing.orderTotalWithoutDiscount.val + shippingOption.shippingAmountRaw;
    
    pricing.orderTotalWithoutDiscount.fmt = $filter('currency')(pricing.orderTotalWithoutDiscount.val.toFixed(2));
  };

  /*var cartItems = lf.data.xhr.shop.softgoodsCart.items;
  if (cartItems.length) {
    gtmService.pushImpression(cartItems, 'cart');
  }*/
});
